import cookiejs from "cookiejs";
import Cache from './cache';
import { fetchJson } from './request';
// import NavigationHelper from './navigation-helper';

const USER_SESSID = cookiejs.get('PHPSESSID');
const cache = new Cache('tp_user_meta_', 300);

/**
 * Prüft, ob eine SESSION existiert.
 * @returns {bool}
 */
export function isLoggedIn() {
    return !!USER_SESSID;
}

/**
 * Ermittelt Daten zum angemeldeten Benutzer.
 *
 * Die Informationen werden vom Server geholt und
 * im LocalStorage gecached.
 * @returns {Promise} Rejects wenn keine Benutzerdaten vorhanden, z.B. wenn nicht angemeldet.
 */
export async function getInfo() {
    if (!isLoggedIn()) {
        cache.remove('info');
        return Promise.reject();
    }
    let info = cache.get('info');
    if (info === null || info.sessid !== USER_SESSID) {
        cache.remove('info');
        info = await fetchJson('/default/user/meta-info/');
        if (info === null || !info.id) {
            return Promise.reject();
        }
        info.sessid = USER_SESSID;
    }
    cache.set('info', info);
    return info;
}

/**
 * Setzt CSS-Styles und Klassen, um Sichtbarkeiten zu steuern und Benutzerinformationen
 * verfügbar zu machen.
 *
 * Sichtbarkeits-Klassen: /build/gulp/responsive_themes/styles/components/user.css
 *
 * Benutzerinfos als content im before-Pseudoelement:
 * [data-user="id"]
 * [data-user="salutation"]
 * [data-user="firstname"]
 * [data-user="lastname"]
 * [data-user="username"]
 * [data-user="companyname"]
 * [data-user="greeting"]
 * [data-user="trusted_status"]
 */
export async function initInfoStyles() {
    const info = await getInfo();
    const styles = document.createElement('style');
    Object.entries(info).forEach(function ([key, value]) {
        if (key === 'sessid') {
            return; // Die Session ID brauchen wir hier nicht.
        }
        // Booleans werden zu body-Klassem
        if (value === true) {
            document.body.classList.add(`user-${key.replace(/_/g, '-')}`);
        } else if (value === false) {
            document.body.classList.remove(`user-${key.replace(/_/g, '-')}`);
        } else if (value) {
            // alles andere wird zu Content
            styles.textContent += `[data-user="${key}"]:before { content: ${JSON.stringify(value)}; } `;
        }
    });
    document.head.appendChild(styles);
}

export async function reload() {
    cache.remove('info');
    await getInfo();
    await initInfoStyles();
    return;
}

export default {
    isLoggedIn,
    getInfo,
    initInfoStyles,
    reload
}
